const DOCTORS_DESKTOP_MQ = '(min-width: 64rem)';
let doctorsPositionResizeBound = false;

/**
 * Equalize `.doctors__position` height to the tallest card in a gallery (desktop).
 *
 * @param {HTMLElement} stage Doctors gallery root.
 * @return {void}
 */
function equalizeDoctorsPositions(stage) {
	const positions = Array.from(stage.querySelectorAll('.doctors__position'));

	if (0 === positions.length) {
		return;
	}

	positions.forEach((element) => {
		element.style.minHeight = '';
		element.style.height = '';
	});

	if (!window.matchMedia(DOCTORS_DESKTOP_MQ).matches) {
		return;
	}

	let maxHeight = 0;

	positions.forEach((element) => {
		maxHeight = Math.max(maxHeight, element.offsetHeight);
	});

	if (maxHeight <= 0) {
		return;
	}

	const height = `${maxHeight}px`;

	positions.forEach((element) => {
		element.style.minHeight = height;
	});
}

/**
 * Doctors block interactions: touch activation and keyboard focus.
 *
 * Modal opening reuses `initModalTriggers()` with `data-specialist-id`.
 *
 * @return {void}
 */
export function initDoctors() {
	const blocks = document.querySelectorAll('[data-doctors]');

	const equalizeAllDoctorPositions = () => {
		blocks.forEach((block) => {
			const stage = block.querySelector('[data-doctors-stage]');

			if (stage instanceof HTMLElement) {
				equalizeDoctorsPositions(stage);
			}
		});
	};

	blocks.forEach((block) => {
		const stage = block.querySelector('[data-doctors-stage]');

		if (!stage) {
			return;
		}

		const cards = Array.from(stage.querySelectorAll('[data-doctors-card]'));

		if (0 === cards.length) {
			return;
		}

		/**
		 * @param {HTMLElement|null} card
		 * @return {void}
		 */
		const setActiveCard = (card) => {
			cards.forEach((item) => {
				item.classList.toggle('is-active', item === card);
			});
		};

		cards.forEach((card) => {
			card.addEventListener('mouseenter', () => {
				if (window.matchMedia('(hover: hover)').matches) {
					setActiveCard(card);
				}
			});

			card.addEventListener('focusin', () => {
				setActiveCard(card);
			});

			card.addEventListener('click', (event) => {
				if (event.target.closest('[data-modal-trigger], a')) {
					return;
				}

				if (!window.matchMedia('(hover: none)').matches) {
					return;
				}

				if (card.classList.contains('is-active')) {
					setActiveCard(null);
					return;
				}

				setActiveCard(card);
			});
		});

		stage.addEventListener('mouseleave', () => {
			if (window.matchMedia('(hover: hover)').matches) {
				setActiveCard(null);
			}
		});
	});

	equalizeAllDoctorPositions();

	if (!doctorsPositionResizeBound) {
		doctorsPositionResizeBound = true;

		let resizeTimer = 0;

		window.addEventListener('resize', () => {
			window.clearTimeout(resizeTimer);
			resizeTimer = window.setTimeout(equalizeAllDoctorPositions, 150);
		});
	}
}
